/**
 * Create or update a tenant user invitation. If it's a new invitation
 * without an email address then the return will include passcodeText.
 * The caller is expected to do something to communicate it to the user.
 */
export const tenantUserInvitationSaveSpec = {
    uri: '/t/[tenant]/user/invitation/[invitation]',
    method: 'PUT',
};
